/**
 * Grid Layout Hook
 *
 * Hook for managing grid layout state.
 */
import { useDataPlaneStore } from '../store';
import type { GridItem } from '../store';

/**
 * Get the current grid layout
 */
export function useGridLayout() {
  return useDataPlaneStore((state) => ({
    layout: state.grid.layout,
    config: state.grid.config,
  }));
}

/**
 * Get grid layout management functions
 */
export function useGridLayoutActions() {
  const addGridItem = useDataPlaneStore((state) => state.addGridItem);
  const removeGridItem = useDataPlaneStore((state) => state.removeGridItem);
  const updateGridItem = useDataPlaneStore((state) => state.updateGridItem);
  const clearGrid = useDataPlaneStore((state) => state.clearGrid);

  return {
    addGridItem,
    removeGridItem,
    updateGridItem,
    clearGrid,
  };
}

/**
 * Get a specific grid item by ID
 */
export function useGridItem(id: string): GridItem | undefined {
  return useDataPlaneStore((state) => state.grid.layout.find((item) => item.id === id));
}

/**
 * Check if a grid position is occupied
 */
export function useIsGridPositionOccupied(col: number, row: number): boolean {
  return useDataPlaneStore((state) =>
    state.grid.layout.some(
      (item) =>
        col >= item.col &&
        col < item.col + item.colSpan &&
        row >= item.row &&
        row < item.row + item.rowSpan,
    ),
  );
}
